module.exports = __webpack_public_path__ + "images/img-3iBhcs_.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/ru/ranks/1.jpg
// module id = 2034
// module chunks = 0